module.exports = __webpack_public_path__ + "static/img/pay-6.3badc6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/pay-6.png
// module id = TEmZ
// module chunks = 1